// import React, { useContext, useState, useEffect } from 'react';
// import { Controller, useForm, useFieldArray } from 'react-hook-form';
// import { Box, Typography, Checkbox, FormGroup, FormControlLabel, TextField, Button, Grid, IconButton, Card } from '@mui/material';
// import { Add as AddIcon, Remove as RemoveIcon } from '@mui/icons-material';
// import { UserProfileContext } from '../UserProfile';
// import { ProviderServices } from '../CrudServices';
// import Swal from 'sweetalert2';
// import Loading from '../../../components/Loader/Loading';
// import { useParams } from 'react-router-dom';

// const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

// const WorkingHours = ({ fetchedData }) => {
//   const {id} = useParams();
//   const { availabilityDetailData, setAvailabilityDetailData } = useContext(UserProfileContext);
//   const [isLoading, setIsLoading] = useState(false);
//   const [hasDefaultSlots, setHasDefaultSlots] = useState(false);

//   // Helper function to convert time string to minutes for comparison
//   const timeToMinutes = (timeStr) => {
//     const [hours, minutes] = timeStr.split(':').map(Number);
//     return hours * 60 + minutes;
//   };

//   // Helper function to convert minutes back to time string
//   const minutesToTime = (minutes) => {
//     const hours = Math.floor(minutes / 60);
//     const mins = minutes % 60;
//     return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
//   };

//   // Helper function to get the latest end time from existing slots
//   const getLatestEndTime = (slots) => {
//     if (!slots || slots.length === 0) return '09:00';
    
//     const sortedSlots = slots
//       .filter(slot => slot.startTime && slot.endTime)
//       .sort((a, b) => timeToMinutes(a.endTime) - timeToMinutes(b.endTime));
    
//     return sortedSlots.length > 0 ? sortedSlots[sortedSlots.length - 1].endTime : '09:00';
//   };

//   // Helper function to check if default slots can fit and return appropriate slots
//   const getDefaultSlotsForDay = (existingSlots) => {
//     const defaultStart = timeToMinutes('09:00');
//     const defaultEnd = timeToMinutes('18:30');
    
//     if (!existingSlots || existingSlots.length === 0) {
//       return [{ startTime: '09:00', endTime: '18:30' }];
//     }

//     // Sort existing slots by start time
//     const sortedSlots = existingSlots
//       .filter(slot => slot.startTime && slot.endTime)
//       .sort((a, b) => timeToMinutes(a.startTime) - timeToMinutes(b.startTime));

//     // Check if 9-18:30 already exists or overlaps
//     const hasOverlap = sortedSlots.some(slot => {
//       const slotStart = timeToMinutes(slot.startTime);
//       const slotEnd = timeToMinutes(slot.endTime);
//       return (defaultStart < slotEnd && defaultEnd > slotStart);
//     });

//     if (!hasOverlap) {
//       return [{ startTime: '09:00', endTime: '18:30' }];
//     }

//     // Find the latest end time and add remaining time after it
//     const latestEndTime = getLatestEndTime(sortedSlots);
//     const latestEndMinutes = timeToMinutes(latestEndTime);
    
//     // If latest end time is before 18:30, add the remaining time
//     if (latestEndMinutes < defaultEnd) {
//       const remainingStartTime = minutesToTime(latestEndMinutes);
//       return [{ startTime: remainingStartTime, endTime: '18:30' }];
//     }

//     return []; // No slots to add if everything overlaps
//   };
 
//   const prepopulateData = (fetchedData) => {
//     return days.map(day => {
//       const dayData = fetchedData.dayTimeSlots.find(slot => slot.day === day);
//       return {
//         day,
//         isSelected: !!dayData?.slots.length,
//         slots: dayData ? dayData.slots : [],
//         defaultSlots: [{ startTime: '09:00', endTime: '18:30' }]
//       };
//     });
//   };

//   const { control, handleSubmit, setValue, formState: { errors, isDirty }, watch, reset } = useForm({
//     mode: 'onChange',
//     defaultValues: {
//       userId: availabilityDetailData?.userId || id>0 && id || '',
//       dayTimeSlots: prepopulateData(availabilityDetailData)
//     }
//   });

//   useEffect(() => {
//     console.log("availabilityDetailData",availabilityDetailData);
//     if (availabilityDetailData.userId > 0 || id>0) {
//       const fetchProviderTimeSlots = async () => {
//         setIsLoading(true);
//         const timeSlotList = await ProviderServices.fetchProviderTimeSlots(availabilityDetailData.userId || id);
//         setAvailabilityDetailData(timeSlotList.data);
//         setIsLoading(false);
//       }
//       fetchProviderTimeSlots();
//     }
//   }, []);

//   useEffect(() => {
//     if (availabilityDetailData) {
//       reset({
//         userId: availabilityDetailData.userId || '',
//         dayTimeSlots: prepopulateData(availabilityDetailData)
//       });
//     }
//   }, [availabilityDetailData, reset]);

//   const { fields } = useFieldArray({
//     control,
//     name: "dayTimeSlots"
//   });

//   // Effect to check default slots status
//   useEffect(() => {
//     const currentFields = watch('dayTimeSlots');
    
//     // Check if ALL days have default slot
//     const allHaveDefault = currentFields.every(field => 
//       field.slots.some(slot => 
//         slot.startTime === '09:00:00' && slot.endTime === '18:30:00'
//       )
//     );
  
//     setHasDefaultSlots(allHaveDefault);
//   }, [watch('dayTimeSlots')]);
  
//   const handleDefaultTimeSlots = () => {
//     const currentFields = watch('dayTimeSlots');
  
//     const updatedFields = currentFields.map(field => {
//       const defaultSlotsToAdd = getDefaultSlotsForDay(field.slots);
      
//       return {
//         ...field,
//         isSelected: true,
//         slots: [
//           ...field.slots,
//           ...defaultSlotsToAdd
//         ]
//       };
//     });
  
//     setValue('dayTimeSlots', updatedFields, {shouldValidate: true, shouldDirty: true});
//   };

//   // Function to add new slot with appropriate start time
//   const addNewSlot = (dayIndex, currentSlots) => {
//     const latestEndTime = getLatestEndTime(currentSlots);
//     const latestEndMinutes = timeToMinutes(latestEndTime);
    
//     // Ensure new slot starts at least 30 minutes after the latest end time
//     const newStartMinutes = latestEndMinutes + 30;
//     const newStartTime = minutesToTime(newStartMinutes);
    
//     const newSlot = { startTime: newStartTime, endTime: '' };
//     return [...currentSlots, newSlot];
//   };

//   // Function to validate time slot
//   const validateTimeSlot = (startTime, endTime, currentSlots, currentSlotIndex) => {
//     if (!startTime || !endTime) return null;
    
//     const startMinutes = timeToMinutes(startTime);
//     const endMinutes = timeToMinutes(endTime);
    
//     // Check if end time is before or equal to start time
//     if (endMinutes <= startMinutes) {
//       return "End time must be after start time";
//     }
    
//     // Check if start time is before previous slot's end time
//     if (currentSlotIndex > 0 && currentSlots[currentSlotIndex - 1]?.endTime) {
//       const previousEndMinutes = timeToMinutes(currentSlots[currentSlotIndex - 1].endTime);
//       if (startMinutes < previousEndMinutes) {
//         return `Start time must be after previous slot's end time (${currentSlots[currentSlotIndex - 1].endTime})`;
//       }
//     }
    
//     // Check if this slot overlaps with other slots (excluding current slot)
//     for (let i = 0; i < currentSlots.length; i++) {
//       if (i === currentSlotIndex) continue; // Skip current slot
      
//       const otherSlot = currentSlots[i];
//       if (!otherSlot.startTime || !otherSlot.endTime) continue;
      
//       const otherStartMinutes = timeToMinutes(otherSlot.startTime);
//       const otherEndMinutes = timeToMinutes(otherSlot.endTime);
      
//       // Check for overlap
//       if (startMinutes < otherEndMinutes && endMinutes > otherStartMinutes) {
//         return "Time slot overlaps with another slot";
//       }
//     }
    
//     return null; // No error
//   };

//   const onSubmit = async (data) => {
//     const selectedDays = data.dayTimeSlots.filter(day => day.isSelected && day.slots.some(slot => slot.startTime && slot.endTime));
    
//     if (selectedDays.length === 0) {
//       Swal.fire("Error", "Please select at least one day and add time slots.", "error");
//       return;
//     }

//     setIsLoading(true);
//     const formattedData = {
//       userId: data.userId,
//       dayTimeSlots: selectedDays.map(({ day, slots }) => ({
//         day,
//         slots: slots.filter(slot => slot.startTime && slot.endTime)
//       }))
//     };

//     try {
//       const timeslotCreateResponse = await ProviderServices.updateTimeSlot(formattedData);
//       if (timeslotCreateResponse.success == '1') {
//         Swal.fire("Success", "Time slots updated successfully", "success");
//         setAvailabilityDetailData(timeslotCreateResponse.data);
//       } else {
//         Swal.fire("Error", "Something went wrong", "error");
//       }
//     } catch (error) {
//       Swal.fire("Error", "An error occurred while updating time slots", "error");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     <Box component={'form'} onSubmit={handleSubmit(onSubmit)}>
//       {isLoading && <Loading />}
//       <Grid container spacing={2}>
//         <Grid item xs={12} lg={7}>
//           <Card sx={{}}>
//             <Box sx={{p:'.5% 2%',border:'2px solid lightGray',bgcolor:'lightGray'}}>
//               <Typography sx={{fontWeight:'600',fontSize:'0.85rem'}}>Working Hours</Typography>
//             </Box>
//             <Box sx={{p:'2%'}}>
//               <Button variant='outlined' size='small' onClick={handleDefaultTimeSlots}>
//                 Add default time slots (9 AM - 6:30 PM) to all days
//               </Button>
//               <FormGroup>
//                 {fields.map((field, index) => {
//                   const isSelected = watch(`dayTimeSlots.${index}.isSelected`);
//                   return (
//                     <Box key={field.id} sx={{ mb: 1 }}>
//                       <Controller
//                         name={`dayTimeSlots.${index}.isSelected`}
//                         control={control}
//                         render={({ field: { onChange, value } }) => (
//                           <FormControlLabel
//                             sx={{
//                               '& .MuiFormControlLabel-label': {
//                                 fontSize:'.75rem'
//                               },
//                               '& .MuiCheckbox-root': {
//                                 transform:'scale(0.8)',
//                                 padding:'.25rem'
//                               }
//                             }}
//                             control={
//                               <Checkbox 
//                                 checked={value} 
//                                 onChange={(e) => {
//                                   // When unchecking, clear but keep custom slots
//                                   if (!e.target.checked) {
//                                     const currentSlots = watch(`dayTimeSlots.${index}.slots`);
//                                     const customSlots = currentSlots.filter(slot => 
//                                       !field.defaultSlots.some(
//                                         defaultSlot => 
//                                           defaultSlot.startTime === slot.startTime && 
//                                           defaultSlot.endTime === slot.endTime
//                                       )
//                                     );
                                    
//                                     // Update slots to keep custom slots
//                                     setValue(`dayTimeSlots.${index}.slots`, customSlots);
//                                   }
                                  
//                                   // Change the selection
//                                   onChange(e.target.checked);
//                                 }} 
//                               />
//                             }
//                             label={field.day}
//                           />
//                         )}
//                       />
//                       {isSelected && (
//                         <Controller
//                           name={`dayTimeSlots.${index}.slots`}
//                           control={control}
//                           render={({ field: { value, onChange } }) => (
//                             <>
//                               {value.map((slot, slotIndex) => {
//                                 const timeError = validateTimeSlot(slot.startTime, slot.endTime, value, slotIndex);
//                                 return (
//                                 <Grid container spacing={2} key={slotIndex} sx={{ mb: 1, ml: 4 }}>
//                                   <Grid item xs={5}>
//                                     <TextField
//                                       label="Start Time"
//                                       type="time"
//                                       size="small"
//                                       value={slot.startTime}
//                                       onChange={(e) => {
//                                         const newSlots = [...value];
//                                         const newStartTime = e.target.value;
                                        
//                                         // Check if this slot has a previous slot
//                                         if (slotIndex > 0 && value[slotIndex - 1]?.endTime) {
//                                           const previousEndTime = value[slotIndex - 1].endTime;
//                                           const previousEndMinutes = timeToMinutes(previousEndTime);
//                                           const newStartMinutes = timeToMinutes(newStartTime);
                                          
//                                           if (newStartMinutes < previousEndMinutes) {
//                                             Swal.fire({
//                                               title: "Invalid Time",
//                                               text: `Start time must be after previous slot's end time (${previousEndTime})`,
//                                               icon: "error",
//                                               timer: 3000,
//                                               showConfirmButton: false
//                                             });
//                                             return;
//                                           }
//                                         }
                                        
//                                         // If there's an end time, validate it's after start time
//                                         if (newSlots[slotIndex].endTime) {
//                                           const startMinutes = timeToMinutes(newStartTime);
//                                           const endMinutes = timeToMinutes(newSlots[slotIndex].endTime);
                                          
//                                           if (endMinutes <= startMinutes) {
//                                             // Clear end time if it becomes invalid
//                                             newSlots[slotIndex].endTime = '';
//                                           }
//                                         }
                                        
//                                         newSlots[slotIndex].startTime = newStartTime;
//                                         onChange(newSlots);
//                                       }}
//                                       InputLabelProps={{ shrink: true }}
//                                       inputProps={{ 
//                                         step: 1,
//                                         style: {fontSize:'.75rem'},
//                                         min: slotIndex > 0 && value[slotIndex - 1]?.endTime 
//                                           ? value[slotIndex - 1].endTime 
//                                           : undefined
//                                       }}
//                                       error={!!timeError}
//                                       fullWidth
//                                     />
//                                   </Grid>
//                                   <Grid item xs={5}>
//                                     <TextField
//                                       label="End Time"
//                                       type="time"
//                                       size="small"
//                                       value={slot.endTime}
//                                       onChange={(e) => {
//                                         const newSlots = [...value];
//                                         const newEndTime = e.target.value;
//                                         const startTime = newSlots[slotIndex].startTime;
                                        
//                                         // Prevent setting end time before start time
//                                         if (startTime && newEndTime) {
//                                           const startMinutes = timeToMinutes(startTime);
//                                           const endMinutes = timeToMinutes(newEndTime);
                                          
//                                           if (endMinutes <= startMinutes) {
//                                             Swal.fire({
//                                               title: "Invalid Time",
//                                               text: "End time must be after start time",
//                                               icon: "error",
//                                               timer: 2000,
//                                               showConfirmButton: false
//                                             });
//                                             return;
//                                           }
//                                         }
                                        
//                                         newSlots[slotIndex].endTime = newEndTime;
//                                         onChange(newSlots);
//                                       }}
//                                       InputLabelProps={{ shrink: true }}
//                                       inputProps={{ 
//                                         step: 1,
//                                         style: {fontSize:'.75rem'},
//                                         min: slot.startTime || undefined
//                                       }}
//                                       error={!!timeError}
//                                       helperText={timeError}
//                                       fullWidth
//                                     />
//                                   </Grid>
//                                   <Grid item xs={2}>
//                                     <IconButton 
//                                       size='small'
//                                       onClick={() => {
//                                         const newSlots = value.filter((_, i) => i !== slotIndex);
//                                         onChange(newSlots);
//                                       }} 
//                                       color="error"
//                                     >
//                                       <RemoveIcon />
//                                     </IconButton>
//                                   </Grid>
//                                 </Grid>
//                                 );
//                               })}
//                               {/* Limit to 2 slots */}
//                               {value.length < 2 && (
//                                 <Box textAlign={'right'}>
//                                   <Button 
//                                     size='small'
//                                     startIcon={<AddIcon />} 
//                                     onClick={() => onChange(addNewSlot(index, value))}
//                                     sx={{  ml: 4 }}
//                                   >
//                                     Add Slot
//                                   </Button>
//                                 </Box>
//                               )}
//                             </>
//                           )}
//                         />
//                       )}
//                     </Box>
//                   );
//                 })}
//               </FormGroup>
//             </Box>
//             <Box sx={{textAlign:'center',my:'5%'}}>
//               <Button disabled={!isDirty} type="submit" variant="contained" color="primary" size='small'>
//                 Save Working Hours
//               </Button>
//             </Box>
//           </Card>
//         </Grid>
//       </Grid>
//     </Box>
//   );
// };

// export default WorkingHours;
import React, { useContext, useState, useEffect } from 'react';
import { Controller, useForm, useFieldArray } from 'react-hook-form';
import { Box, Typography, Checkbox, FormGroup, FormControlLabel, TextField, Button, Grid, IconButton, Card } from '@mui/material';
import { Add as AddIcon, Remove as RemoveIcon } from '@mui/icons-material';
import { UserProfileContext } from '../UserProfile';
import { ProviderServices } from '../CrudServices';
import Swal from 'sweetalert2';
import Loading from '../../../components/Loader/Loading';
import { useParams } from 'react-router-dom';

const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

const WorkingHours = ({ fetchedData }) => {
  const {id} = useParams();
  const { availabilityDetailData, setAvailabilityDetailData } = useContext(UserProfileContext);
  const [isLoading, setIsLoading] = useState(false);
  const [hasDefaultSlots, setHasDefaultSlots] = useState(false);

  // Helper function to convert time string to minutes for comparison
  const timeToMinutes = (timeStr) => {
    const [hours, minutes] = timeStr.split(':').map(Number);
    return hours * 60 + minutes;
  };

  // Helper function to convert minutes back to time string
  const minutesToTime = (minutes) => {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
  };

  // Helper function to get the latest end time from existing slots
  const getLatestEndTime = (slots) => {
    if (!slots || slots.length === 0) return '09:00';
    
    const sortedSlots = slots
      .filter(slot => slot.startTime && slot.endTime)
      .sort((a, b) => timeToMinutes(a.endTime) - timeToMinutes(b.endTime));
    
    return sortedSlots.length > 0 ? sortedSlots[sortedSlots.length - 1].endTime : '09:00';
  };

  // Helper function to check if default slots can fit and return appropriate slots
  const getDefaultSlotsForDay = (existingSlots) => {
    const defaultStart = timeToMinutes('09:00');
    const defaultEnd = timeToMinutes('18:30');
    
    if (!existingSlots || existingSlots.length === 0) {
      return [{ startTime: '09:00', endTime: '18:30' }];
    }

    // Sort existing slots by start time
    const sortedSlots = existingSlots
      .filter(slot => slot.startTime && slot.endTime)
      .sort((a, b) => timeToMinutes(a.startTime) - timeToMinutes(b.startTime));

    // Check if 9-18:30 already exists or overlaps
    const hasOverlap = sortedSlots.some(slot => {
      const slotStart = timeToMinutes(slot.startTime);
      const slotEnd = timeToMinutes(slot.endTime);
      return (defaultStart < slotEnd && defaultEnd > slotStart);
    });

    if (!hasOverlap) {
      return [{ startTime: '09:00', endTime: '18:30' }];
    }

    // Find the latest end time and add remaining time after it
    const latestEndTime = getLatestEndTime(sortedSlots);
    const latestEndMinutes = timeToMinutes(latestEndTime);
    
    // If latest end time is before 18:30, add the remaining time
    if (latestEndMinutes < defaultEnd) {
      const remainingStartTime = minutesToTime(latestEndMinutes);
      return [{ startTime: remainingStartTime, endTime: '18:30' }];
    }

    return []; // No slots to add if everything overlaps
  };
 
  const prepopulateData = (fetchedData) => {
    return days.map(day => {
      const dayData = fetchedData.dayTimeSlots.find(slot => slot.day === day);
      return {
        day,
        isSelected: !!dayData?.slots.length,
        slots: dayData ? dayData.slots : [],
        defaultSlots: [{ startTime: '09:00', endTime: '18:30' }]
      };
    });
  };

  const { control, handleSubmit, setValue, formState: { errors, isDirty }, watch, reset } = useForm({
    mode: 'onChange',
    defaultValues: {
      userId: availabilityDetailData?.userId || id>0 && id || '',
      dayTimeSlots: prepopulateData(availabilityDetailData)
    }
  });

  useEffect(() => {
    console.log("availabilityDetailData",availabilityDetailData);
    if (availabilityDetailData.userId > 0 || id>0) {
      const fetchProviderTimeSlots = async () => {
        setIsLoading(true);
        const timeSlotList = await ProviderServices.fetchProviderTimeSlots(availabilityDetailData.userId || id);
        setAvailabilityDetailData(timeSlotList.data);
        setIsLoading(false);
      }
      fetchProviderTimeSlots();
    }
  }, []);

  useEffect(() => {
    if (availabilityDetailData) {
      reset({
        userId: availabilityDetailData.userId || '',
        dayTimeSlots: prepopulateData(availabilityDetailData)
      });
    }
  }, [availabilityDetailData, reset]);

  const { fields } = useFieldArray({
    control,
    name: "dayTimeSlots"
  });

  // Effect to check default slots status
  useEffect(() => {
    const currentFields = watch('dayTimeSlots');
    
    // Check if ALL days have default slot
    const allHaveDefault = currentFields.every(field => 
      field.slots.some(slot => 
        slot.startTime === '09:00:00' && slot.endTime === '18:30:00'
      )
    );
  
    setHasDefaultSlots(allHaveDefault);
  }, [watch('dayTimeSlots')]);
  
  const handleDefaultTimeSlots = () => {
    const currentFields = watch('dayTimeSlots');
  
    const updatedFields = currentFields.map(field => {
      const defaultSlotsToAdd = getDefaultSlotsForDay(field.slots);
      
      return {
        ...field,
        isSelected: true,
        slots: [
          ...field.slots,
          ...defaultSlotsToAdd
        ]
      };
    });
  
    setValue('dayTimeSlots', updatedFields, {shouldValidate: true, shouldDirty: true});
  };

  // Function to add new slot with appropriate start time
  const addNewSlot = (dayIndex, currentSlots) => {
    const latestEndTime = getLatestEndTime(currentSlots);
    const latestEndMinutes = timeToMinutes(latestEndTime);
    
    // Ensure new slot starts at least 30 minutes after the latest end time
    const newStartMinutes = latestEndMinutes + 30;
    const newStartTime = minutesToTime(newStartMinutes);
    
    const newSlot = { startTime: newStartTime, endTime: '' };
    return [...currentSlots, newSlot];
  };

  // Function to validate start time
  const validateStartTime = (startTime, currentSlots, currentSlotIndex) => {
    if (!startTime) return null;
    
    const startMinutes = timeToMinutes(startTime);
    
    // Check if start time is before previous slot's end time
    if (currentSlotIndex > 0 && currentSlots[currentSlotIndex - 1]?.endTime) {
      const previousEndMinutes = timeToMinutes(currentSlots[currentSlotIndex - 1].endTime);
      if (startMinutes < previousEndMinutes) {
        return `Start time must be after ${currentSlots[currentSlotIndex - 1].endTime}`;
      }
    }
    
    return null; // No error
  };

  // Function to validate end time
  const validateEndTime = (startTime, endTime, currentSlots, currentSlotIndex) => {
    if (!startTime || !endTime) return null;
    
    const startMinutes = timeToMinutes(startTime);
    const endMinutes = timeToMinutes(endTime);
    
    // Check if end time is before or equal to start time
    if (endMinutes <= startMinutes) {
      return "End time must be after start time";
    }
    
    // Check if this slot overlaps with other slots (excluding current slot)
    for (let i = 0; i < currentSlots.length; i++) {
      if (i === currentSlotIndex) continue; // Skip current slot
      
      const otherSlot = currentSlots[i];
      if (!otherSlot.startTime || !otherSlot.endTime) continue;
      
      const otherStartMinutes = timeToMinutes(otherSlot.startTime);
      const otherEndMinutes = timeToMinutes(otherSlot.endTime);
      
      // Check for overlap
      if (startMinutes < otherEndMinutes && endMinutes > otherStartMinutes) {
        return "Time slot overlaps with another slot";
      }
    }
    
    return null; // No error
  };

  const onSubmit = async (data) => {
    const selectedDays = data.dayTimeSlots.filter(day => day.isSelected && day.slots.some(slot => slot.startTime && slot.endTime));
    
    if (selectedDays.length === 0) {
      Swal.fire("Error", "Please select at least one day and add time slots.", "error");
      return;
    }

    setIsLoading(true);
    const formattedData = {
      userId: data.userId,
      dayTimeSlots: selectedDays.map(({ day, slots }) => ({
        day,
        slots: slots.filter(slot => slot.startTime && slot.endTime)
      }))
    };

    try {
      const timeslotCreateResponse = await ProviderServices.updateTimeSlot(formattedData);
      if (timeslotCreateResponse.success == '1') {
        Swal.fire("Success", "Time slots updated successfully", "success");
        setAvailabilityDetailData(timeslotCreateResponse.data);
      } else {
        Swal.fire("Error", "Something went wrong", "error");
      }
    } catch (error) {
      Swal.fire("Error", "An error occurred while updating time slots", "error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box component={'form'} onSubmit={handleSubmit(onSubmit)}>
      {isLoading && <Loading />}
      <Grid container spacing={2}>
        <Grid item xs={12} lg={7}>
          <Card sx={{}}>
            <Box sx={{p:'.5% 2%',border:'2px solid lightGray',bgcolor:'lightGray'}}>
              <Typography sx={{fontWeight:'600',fontSize:'0.85rem'}}>Working Hours</Typography>
            </Box>
            <Box sx={{p:'2%'}}>
              <Button variant='outlined' size='small' onClick={handleDefaultTimeSlots}>
                Add default time slots (9 AM - 6:30 PM) to all days
              </Button>
              <FormGroup>
                {fields.map((field, index) => {
                  const isSelected = watch(`dayTimeSlots.${index}.isSelected`);
                  return (
                    <Box key={field.id} sx={{ mb: 1 }}>
                      <Controller
                        name={`dayTimeSlots.${index}.isSelected`}
                        control={control}
                        render={({ field: { onChange, value } }) => (
                          <FormControlLabel
                            sx={{
                              '& .MuiFormControlLabel-label': {
                                fontSize:'.75rem'
                              },
                              '& .MuiCheckbox-root': {
                                transform:'scale(0.8)',
                                padding:'.25rem'
                              }
                            }}
                            control={
                              <Checkbox 
                                checked={value} 
                                onChange={(e) => {
                                  // When unchecking, clear but keep custom slots
                                  if (!e.target.checked) {
                                    const currentSlots = watch(`dayTimeSlots.${index}.slots`);
                                    const customSlots = currentSlots.filter(slot => 
                                      !field.defaultSlots.some(
                                        defaultSlot => 
                                          defaultSlot.startTime === slot.startTime && 
                                          defaultSlot.endTime === slot.endTime
                                      )
                                    );
                                    
                                    // Update slots to keep custom slots
                                    setValue(`dayTimeSlots.${index}.slots`, customSlots);
                                  }
                                  
                                  // Change the selection
                                  onChange(e.target.checked);
                                }} 
                              />
                            }
                            label={field.day}
                          />
                        )}
                      />
                      {isSelected && (
                        <Controller
                          name={`dayTimeSlots.${index}.slots`}
                          control={control}
                          render={({ field: { value, onChange } }) => (
                            <>
                              {value.map((slot, slotIndex) => {
                                const startTimeError = validateStartTime(slot.startTime, value, slotIndex);
                                const endTimeError = validateEndTime(slot.startTime, slot.endTime, value, slotIndex);
                                return (
                                <Grid container spacing={2} key={slotIndex} sx={{ mb: 1, ml: 4 }}>
                                  <Grid item xs={5}>
                                    <TextField
                                      label="Start Time"
                                      type="time"
                                      size="small"
                                      value={slot.startTime}
                                      onChange={(e) => {
                                        const newSlots = [...value];
                                        const newStartTime = e.target.value;
                                        
                                        // If there's an end time, validate it's after start time
                                        if (newSlots[slotIndex].endTime) {
                                          const startMinutes = timeToMinutes(newStartTime);
                                          const endMinutes = timeToMinutes(newSlots[slotIndex].endTime);
                                          
                                          if (endMinutes <= startMinutes) {
                                            // Clear end time if it becomes invalid
                                            newSlots[slotIndex].endTime = '';
                                          }
                                        }
                                        
                                        newSlots[slotIndex].startTime = newStartTime;
                                        onChange(newSlots);
                                      }}
                                      InputLabelProps={{ shrink: true }}
                                      inputProps={{ 
                                        step: 1,
                                        style: {fontSize:'.75rem'},
                                        min: slotIndex > 0 && value[slotIndex - 1]?.endTime 
                                          ? value[slotIndex - 1].endTime 
                                          : undefined
                                      }}
                                      error={!!startTimeError}
                                      helperText={startTimeError}
                                      fullWidth
                                    />
                                  </Grid>
                                  <Grid item xs={5}>
                                    <TextField
                                      label="End Time"
                                      type="time"
                                      size="small"
                                      value={slot.endTime}
                                      onChange={(e) => {
                                        const newSlots = [...value];
                                        const newEndTime = e.target.value;
                                        
                                        newSlots[slotIndex].endTime = newEndTime;
                                        onChange(newSlots);
                                      }}
                                      InputLabelProps={{ shrink: true }}
                                      inputProps={{ 
                                        step: 1,
                                        style: {fontSize:'.75rem'},
                                        min: slot.startTime || undefined
                                      }}
                                      error={!!endTimeError}
                                      helperText={endTimeError}
                                      fullWidth
                                    />
                                  </Grid>
                                  <Grid item xs={2}>
                                    <IconButton 
                                      size='small'
                                      onClick={() => {
                                        const newSlots = value.filter((_, i) => i !== slotIndex);
                                        onChange(newSlots);
                                      }} 
                                      color="error"
                                    >
                                      <RemoveIcon />
                                    </IconButton>
                                  </Grid>
                                </Grid>
                                );
                              })}
                              {/* Limit to 2 slots */}
                              {value.length < 2 && (
                                <Box textAlign={'right'}>
                                  <Button 
                                    size='small'
                                    startIcon={<AddIcon />} 
                                    onClick={() => onChange(addNewSlot(index, value))}
                                    sx={{  ml: 4 }}
                                  >
                                    Add Slot
                                  </Button>
                                </Box>
                              )}
                            </>
                          )}
                        />
                      )}
                    </Box>
                  );
                })}
              </FormGroup>
            </Box>
            <Box sx={{textAlign:'center',my:'5%'}}>
              <Button disabled={!isDirty} type="submit" variant="contained" color="primary" size='small'>
                Save Working Hours
              </Button>
            </Box>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default WorkingHours;